import React from 'react'
import ByTheNumbers from '../../../react4xp/components/ByTheNumbers'

function ByTheNumbersPart({bgColor, intro, title, facts}) {
  return (
    <ByTheNumbers
      bgColor={bgColor}
      title={title}
      intro={intro}
      facts={facts?.map(fact => ({
        icon: fact.icon?.link && {src: fact.icon.link, alt: fact.icon.alt},
        value: fact.value,
        label: fact.label
      }))}
    />
  )
}

export default (props) => <ByTheNumbersPart {...props} />
